export default __webpack_public_path__ + "static/media/36I-114283_-20932_0.4d952d05.jpg";